"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _inputLabel = _interopRequireDefault(require("../../legacy/input-label"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _excluded = ["labelPosition", "showValue"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputLabelContainer = (0, _styledComponents["default"])(function (_ref) {
  var labelPosition = _ref.labelPosition,
      showValue = _ref.showValue,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, props);
}).withConfig({
  displayName: "label__InputLabelContainer",
  componentId: "sc-p10021-0"
})(["", ";"], function (_ref2) {
  var labelPosition = _ref2.labelPosition;
  return labelPosition === "placeholder" ? (0, _styledComponents.css)(["transform:", ";position:absolute;top:0;left:0;right:0;pointer-events:none;transform-origin:0 0;", ";z-index:1;"], function (_ref3) {
    var showValue = _ref3.showValue;
    return showValue ? "translate3d(3px, -3px, 0) scale(0.71)" : "translate3d(0, 0, 0) scale(1)";
  }, (0, _styles.transitionEase)("0.3s", ["transform"])) : null;
});
var FieldLabel = (0, _styledComponents["default"])(_inputLabel["default"]).withConfig({
  displayName: "label__FieldLabel",
  componentId: "sc-p10021-1"
})(["", ";"], (0, _styles.transitionEase)("0.3s", ["color"]));

var sizing = function sizing(labelPosition) {
  return labelPosition === "placeholder" ? _utils.defaultFontSize : _utils.labelFontSize;
};

var spacing = function spacing(labelPosition) {
  return labelPosition === "placeholder" ? _utils.defaultSpacing : _utils.labelSpacing;
};

var Label = function Label(_ref4) {
  var error = _ref4.error,
      fieldId = _ref4.fieldId,
      label = _ref4.label,
      labelPosition = _ref4.labelPosition,
      showValue = _ref4.showValue,
      hasFocus = _ref4.hasFocus,
      hasHover = _ref4.hasHover;
  return /*#__PURE__*/_react["default"].createElement(InputLabelContainer, {
    labelPosition: labelPosition,
    showValue: showValue
  }, /*#__PURE__*/_react["default"].createElement(FieldLabel, _extends({
    color: labelPosition === "placeholder" ? (0, _utils.getTextColor)({
      error: error,
      hasFocus: hasFocus,
      hasHover: hasHover
    }) : "text-helper",
    display: "block",
    htmlFor: fieldId
  }, sizing(labelPosition), spacing(labelPosition)), label));
};

Label.propTypes = {
  /** A boolean to represent whether the label should be disabled */
  error: _propTypes.bool,
  fieldId: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  hasFocus: _propTypes.bool,
  hasHover: _propTypes.bool,

  /** A node that represent form element label */
  label: _propTypes.node,

  /** A string to represent label position */
  labelPosition: _propTypes.string,

  /** A boolean or string to represent whether the label should show */
  showValue: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string])
};
var _default = Label;
exports["default"] = _default;